"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _CustomActivityPopup = _interopRequireDefault(require("./components/CustomActivityPopup"));
var _Item = _interopRequireDefault(require("./components/Item"));
var _previewPopup = _interopRequireDefault(require("./components/previewPopup.vue"));
var _aggregatePageManagement = require("@/api/operationManagement/aggregatePageManagement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AggregatePageManagement',
  components: {
    ItemActivity: _Item.default,
    CustomActivityPopup: _CustomActivityPopup.default,
    previewPopup: _previewPopup.default
  },
  data: function data() {
    return {
      pagination: {
        // currentPage: 1, // 默认第几页
        total: 0 // 条数
      },
      queryData: {
        name: '',
        page: {
          page: 1,
          size: 10
        }
      },
      dataList: []
    };
  },
  created: function created() {
    this.aggregatePageList();
  },
  methods: {
    onPreview: function onPreview(data) {
      this.$refs.previewPopup.open(data);
    },
    // 添加
    onAdd: function onAdd() {
      console.log('添加活动');
      this.$refs.customActivityPopup.open({
        type: 'add',
        name: '添加聚合页'
      });
    },
    // 编辑
    onEditor: function onEditor(item) {
      this.$refs.customActivityPopup.open({
        type: 'editor',
        id: item.id,
        name: '编辑聚合页',
        item: item
      });
    },
    // 刷新
    onRefresh: function onRefresh() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.aggregatePageList();
    },
    // 初始化参数
    onInit: function onInit() {
      this.queryData = {
        name: '',
        page: {
          page: 1,
          size: 10
        }
      };
    },
    // 重置
    onInitialize: function onInitialize() {
      this.onInit();
      this.aggregatePageList();
    },
    // 查询
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.aggregatePageList();
    },
    refreshEditor: function refreshEditor() {
      this.aggregatePageList();
    },
    onDelete: function onDelete(val) {
      var _this = this;
      this.$confirm('是否确认删除此活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.aggregatePageDelete(Number(val.id));
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.aggregatePageList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.aggregatePageList();
    },
    // 列表
    aggregatePageList: function () {
      var _aggregatePageList2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              this.tableLoading = true;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _aggregatePageManagement.aggregatePageList)(params);
            case 1:
              res = _context.v;
              this.tableLoading = false;
              if (res.code === 0) {
                this.dataList = res.data.data;
                this.pagination.total = res.data.total;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function aggregatePageList() {
        return _aggregatePageList2.apply(this, arguments);
      }
      return aggregatePageList;
    }(),
    // 删除活动
    aggregatePageDelete: function () {
      var _aggregatePageDelete2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(id) {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {
                id: id
              };
              _context2.n = 1;
              return (0, _aggregatePageManagement.aggregatePageDelete)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.aggregatePageList();
                this.$notify.success({
                  title: '温馨提示',
                  message: '删除成功'
                });
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function aggregatePageDelete(_x) {
        return _aggregatePageDelete2.apply(this, arguments);
      }
      return aggregatePageDelete;
    }()
  }
};